import { Text } from "@chakra-ui/react";
import { useGetPolicyByIdQuery } from "graphql/queries/generated/queries";
import { useParams } from "react-router-dom";
import { policyAssetFields } from "../PCPolicyAssetFields";
import Page from "./Page";

const PCPoliciesEditPage = () => {
  const { policyId } = useParams();

  const { data, loading, error, refetch } = useGetPolicyByIdQuery({
    variables: {
      id: policyId,
    },
  });

  if (loading) return <Text>Loading...</Text>;
  if (!data) return null;

  return <Page data={data} policyAssetsFields={policyAssetFields} type="PERMANENT_COLLECTION" />;
};

export default PCPoliciesEditPage;
